import { Injectable } from '@angular/core';
import { AppStateService } from './app-state.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})

export class DisplayService {
  loaderState = false;

  constructor(private snackBar: MatSnackBar, private state: AppStateService) {
  }

  showToast(message: string, action: string = '') {
    this.snackBar.open(message, action, {
      duration: 2000
    });
  }

  showLoader(): void {
    this.state.setloaderState(true);
  }

  hideLoader(): void {
    this.state.setloaderState(false);
  }

}
